import { TSubscription } from '../store';

type TContainers = Record<string, { checked: boolean; daysBefore: number }>;

export const getSubscriptionStatus = (
  containers: TContainers,
  totalContainers: number,
  subscriptions?: TSubscription[]
) => {
  const allKeysPresent = Object.keys(containers).length === totalContainers;

  const allSubscribed =
    allKeysPresent &&
    (Object.values(containers).reduce(
      (prevValue, { checked }: $TSFixMe) => prevValue && checked,
      true
    ) as boolean);

  const evenOneSubscribed = !!Object.values(containers).find(
    ({ checked }: $TSFixMe) => checked
  );

  const hasNoSubscriptions = !subscriptions || subscriptions.length === 0;

  return {
    allKeysPresent,
    allSubscribed,
    evenOneSubscribed,
    hasNoSubscriptions,
  };
};
